import React, { useEffect } from 'react';
import { Escribano_item } from '../../json/escribanoItem';
import './escribano.css';


const Escribano = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <h3 className='title'>El Escribano</h3>
                <hr className='hr-gob' />
                <h6>El Escribano es una publicación mensual que contiene pequeños extractos de
                    los documentos que forman parte del acervo documental del Archivo Histórico,
                    respetando la ortografía original del documento.</h6>
                <h6> La impresión se realiza
                    con una imprenta tipográfica fabricada a finales del Siglo XIX por la
                    compañía estadounidense Chandler & Price, fundada en 1881 y cerrada en 1964;
                    el tiraje de la publicación “El Escribano”, inicio en diciembre del año 1995,
                    desde entonces se han impreso y distribuido más de 160,000 ejemplares.</h6>
                <h6>Actualmente se realiza un tiraje mensual de 700 impresiones distribuidas
                    a visitantes de la exposición documental y fotográfica, dependencias
                    gubernamentales, instituciones educativas, organismos públicos descentralizados
                    a nivel estatal y nacional (Archivo General de la Nación, Escuela Nacional de
                    Biblioteconomía y Archivonomía, Universidad Nacional Autónoma de México y
                    Congreso de la Unión). </h6>
                <h6>Conforme a los artículos, 2 inciso IX y X; 6, 31 y 98 inciso IX, 
                    de la Ley de Archivos para el Estado de Hidalgo y el artículo 
                    transitorio Noveno de la Ley Orgánica de la Administración 
                    Pública para el Estado de Hidalgo. 
                    El objetivo es difundir el patrimonio documental del Estado, 
                    contribuyendo así al derecho que tienen los ciudadanos de acceder a la cultura.</h6>

            </div>
            <div className='row'>
                {
                    Escribano_item.map((item, index) => (
                        <div key={index} className='col-md-3 col-sm-6 col-12'>
                            <div className='card_container_escribano'>
                                <div className='card_anio'>
                                    <h5>{item.anio}</h5>
                                    {
                                        item.Escribanos.map((trim, index) => (
                                            <div key={index} >
                                                <button className='btn2 btn-secondary dropdown-toggle' type='button' id='{trim.Escribano}' data-bs-toggle='dropdown' aria-expanded='false'>
                                                    {trim.Escribano}
                                                </button>
                                                <ul className='dropdown-menu' aria-labelledby='{trim.Escribano} '>
                                                    <li className='card_trimestre2_escribano'>
                                                        {
                                                            trim.Extras.map((trim2, index2) => (
                                                                <div key={index2}  >

                                                                    <a className='dropdown-item' href={trim2.url2} >{trim2.NombreValor} </a>

                                                                </div>

                                                            ))
                                                        }
                                                    </li>
                                                </ul>

                                            </div>
                                        ))
                                    }

                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Escribano